import Vue from 'vue';
import axios from 'axios';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { _skGlobal, getLazySrc } from 'Root/helpers/_globalHelpers';
import initSentry from 'Root/plugins/sentry';
import createRouter from './router';
import stateModuleRegisterMixin from './mixins/stateModuleRegisterMixin';
import MainApp from './MainApp.vue';

dayjs.extend(utc);
dayjs.extend(customParseFormat);

// добавляем глобальный объект с полезностями
// eslint-disable-next-line no-undef
globalThis._skGlobal = _skGlobal;

Vue.prototype._skGlobal = _skGlobal;
Vue.prototype.$axios = axios;
Vue.prototype.$isSSR = typeof window === 'undefined';
Vue.prototype.$getLazySrc = getLazySrc;

Vue.mixin(stateModuleRegisterMixin);

export default function createApp(store, context) {
  const router = createRouter(store, context);

  initSentry({ router });

  const app = new Vue({
    router,
    store,
    render: (h) => h(MainApp),
  });

  return { app, router, rootComponent: MainApp };
}
